import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    box_container: {
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        borderRadius: '6px',
        height: 'fit-content'
    },
    box_body: {
        padding: '8px',
        position: 'relative',
        backgroundColor: theme.palette.common.white,
        borderRadius: '0 0 6px 6px'
    },
    box_header: {
        fontSize: '18px',
        padding: '8px',
        borderRadius: '6px 6px 0 0',
    },
    default: {
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.grey[100],
    },
    primary: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    secondary: {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.common.white,
    }
}));

export {useStyles}